"use client";

import { ThemeProvider } from "next-themes";
import { FC, PropsWithChildren } from "react";

const AppThemeProvided: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider attribute="class" forcedTheme="light">
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvided;
